export const About = () => {
    const stats = [
        { k: "Mobile", v: "Android & iOS" },
        { k: "Backend", v: "APIs & Cloud" },
        { k: "Scale", v: "Architecture" },
    ];

    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                <div>
                    <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 mb-4 block font-display">
                        About Us
                    </span>
                    <h2
                        data-testid="about-title"
                        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]"
                    >
                        Engineering the systems modern businesses rely on.
                    </h2>
                    <p
                        data-testid="about-paragraph"
                        className="mt-6 text-base lg:text-lg font-normal leading-relaxed text-slate-600"
                    >
                        NextGen Systems is a product engineering studio focused
                        on building high-quality software for ambitious teams.
                        We specialise in mobile app development for{" "}
                        <span className="text-slate-900 font-medium">
                            Android and iOS
                        </span>
                        , robust backend systems, and scalable cloud
                        architecture — turning complex problems into clean,
                        dependable products.
                    </p>
                    <p className="mt-4 text-base lg:text-lg font-normal leading-relaxed text-slate-600">
                        From the first prototype to systems serving millions,
                        our work is defined by precision, maintainability, and
                        a deep respect for the craft.
                    </p>

                    <dl className="mt-10 grid grid-cols-3 gap-6 border-t border-slate-200 pt-8">
                        {stats.map((s) => (
                            <div key={s.k} data-testid={`about-stat-${s.k.toLowerCase()}`}>
                                <dt className="text-xs uppercase tracking-[0.18em] text-slate-400 font-medium">
                                    {s.k}
                                </dt>
                                <dd className="mt-2 font-display text-base lg:text-lg font-semibold text-slate-900">
                                    {s.v}
                                </dd>
                            </div>
                        ))}
                    </dl>
                </div>

                <div className="relative">
                    <div className="absolute -top-4 -left-4 w-full h-full rounded-2xl bg-blue-700/10 hidden sm:block" />
                    <img
                        data-testid="about-image"
                        src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&q=80&auto=format&fit=crop"
                        alt="Modern office professional working on technology"
                        className="relative w-full h-[420px] lg:h-[520px] object-cover rounded-2xl border border-slate-200"
                        loading="lazy"
                    />
                </div>
            </div>
        </section>
    );
};
